// The stream invite link a host posts on an outside channel.
//
// Attribution is parsed off the /signup query string (AppRoot#parseAuthQuery), not
// from a landing cookie, so the UTM params have to ride the link and then be
// forwarded into the signup URL by StreamInvite. utm_campaign carries the team id,
// which makes "members imported by this host" a single SignupAttribution query with
// no schema change.

export const INVITE_UTM_SOURCE = 'host_invite'
export const INVITE_UTM_MEDIUM = 'referral'

// Attribution params SignupAttribution understands; forwarded verbatim if present.
const FORWARDED_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'gbraid',
    'wbraid',
]

export function buildStreamInviteUrl(teamId: string, origin: string): string {
    const url = new URL(`/stream/${teamId}/invite`, origin)
    url.searchParams.set('utm_source', INVITE_UTM_SOURCE)
    url.searchParams.set('utm_medium', INVITE_UTM_MEDIUM)
    url.searchParams.set('utm_campaign', teamId)
    return url.toString()
}

/** Attribution params present on the current invite page, to carry into signup. */
export function forwardedAttributionParams(search: string): Record<string, string> {
    const params = new URLSearchParams(search)
    const forwarded: Record<string, string> = {}
    FORWARDED_PARAMS.forEach(key => {
        const value = params.get(key)
        if (value) forwarded[key] = value
    })
    return forwarded
}

/**
 * Signup URL that auto-joins the stream on account creation.
 * `stream_join` carries the team id (not a single-use token) because a standing
 * link must survive many signups — RegistrationsController authorizes it with the
 * same standing_invitations_allowed check as TeamsController#join.
 */
export function buildStreamSignupUrl(teamId: string, search: string): string {
    const params = new URLSearchParams(forwardedAttributionParams(search))
    params.set('stream_join', teamId)
    return `/signup?${params.toString()}`
}
